var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgLogoutDropdownIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 14,
    height: 15,
    viewBox: "0 0 14 15",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M9.89844 11.4844V12.6562C9.89844 13.9486 8.91716 15 7.71094 15H2.21484C1.00862 15 0.0273438 13.9486 0.0273438 12.6562V2.34375C0.0273438 1.05137 1.00862 0 2.21484 0H7.71094C8.91716 0 9.89844 1.05137 9.89844 2.34375V3.51562C9.89844 3.83926 9.65363 4.10156 9.35156 4.10156C9.0495 4.10156 8.80469 3.83926 8.80469 3.51562V2.34375C8.80469 1.69762 8.314 1.17188 7.71094 1.17188H2.21484C1.61179 1.17188 1.12109 1.69762 1.12109 2.34375V12.6562C1.12109 13.3024 1.61179 13.8281 2.21484 13.8281H7.71094C8.314 13.8281 8.80469 13.3024 8.80469 12.6562V11.4844C8.80469 11.1607 9.0495 10.8984 9.35156 10.8984C9.65363 10.8984 9.89844 11.1607 9.89844 11.4844ZM13.6269 6.49349L12.4023 5.18143C12.1887 4.95255 11.8424 4.95255 11.6289 5.18143C11.4153 5.41019 11.4153 5.78121 11.6289 6.00998L12.4999 6.94336H5.93359C5.63153 6.94336 5.38672 7.20566 5.38672 7.5293C5.38672 7.85294 5.63153 8.11523 5.93359 8.11523H12.4999L11.6289 9.04861C11.4153 9.27738 11.4153 9.6484 11.6289 9.87717C11.7357 9.99161 11.8756 10.0488 12.0155 10.0488C12.1556 10.0488 12.2955 9.99161 12.4023 9.87717L13.6269 8.5651C14.16 7.99393 14.16 7.06467 13.6269 6.49349Z",
    fill: "#0E142C"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 14,
    height: 15,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLogoutDropdownIcon);
export default __webpack_public_path__ + "static/media/logout-dropdown-icon.584cf7d7548ac3d7f8ee4e69913e7e33.svg";
export { ForwardRef as ReactComponent };